@if (featureEnabled) {
  <p-panel header="Campaign Management" [toggleable]="true">
    <div class="p-grid">
      @for (campaignForms of campaignAutomationConfigurationFormArrays; track campaignForms) {
        <div class="campaign-form">
          <label class="campaign-type-header"><b>{{ campaignForms.campaignType }} Campaigns:</b></label>
          <div class="campaign-field">
            <p-checkbox binary="true" [ngModel]="allSelected[campaignForms.campaignType]"
            (onChange)="selectAllCampaigns(campaignForms.forms, campaignForms.campaignType)"></p-checkbox>
            <label class="campaign-name-field">
              @if (allSelected[campaignForms.campaignType]) {
                <b>Deselect All</b>
              }
              @if (!allSelected[campaignForms.campaignType]) {
                <b>Select All</b>
              }
            </label>
          </div>
          @for (campaign of campaignForms.forms; track campaign; let i = $index) {
            <div>
              <form [formGroup]="campaignForms.forms[i]" autoTrackUnsavedChanges>
                <div class="campaign-field">
                  <p-checkbox binary="true" formControlName="updatesEnabled"
                  (onChange)="selectCampaign(campaign, campaignForms)"></p-checkbox>
                  <label (mouseover)="op.toggle($event);" (mouseout)="op.hide()"
                    class="campaign-name-field"><b>{{ campaign.controls.campaign.value }}</b></label>
                    <p-popover #op [style]="{'background-color' : '#151515', 'color' : 'white'}">
                      <div class="flex flex-column gap-3 w-25rem">
                        <div>
                          <span>Campaign Opted In:
                            @if (campaign.get('updatesEnabled').value) {
                              <b>Yes</b>
                            }
                            @if (!campaign.get('updatesEnabled').value) {
                              <b>No</b>
                            }
                          </span>
                          <br>
                            <span>Campaign Last Updated:
                              @if (campaign.get('campaignLastUpdated').value !== null) {
                                <b>{{ campaign.get('campaignLastUpdated').value.date  | date:'shortDate' }}</b>
                              }
                              @if (campaign.get('campaignLastUpdated').value  === null) {
                                <b>N/A</b>
                              }
                            </span>
                            <br>
                              <span>Setting Last Modified:
                                @if (campaign.get('modified').value !== null) {
                                  <b>{{ campaign.get('modified').value.date  | date:'shortDate' }}</b>
                                }
                                @if (campaign.get('modified').value  === null) {
                                  <b>N/A</b>
                                }
                              </span>
                              <br>
                                <span>Setting Modified By:
                                  @if (campaign.get('modifiedUser').value !== null) {
                                    <b>{{ campaign.get('modifiedUser').value }}</b>
                                  }
                                  @if (campaign.get('modifiedUser').value === null) {
                                    <b>N/A</b>
                                  }
                                </span>
                              </div>
                            </div>
                          </p-popover>
                        </div>
                      </form>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="p-grid">
              <div class="tab-panel-input-wrapper">
                <button pButton type="button" [disabled]="!formIsDirty || errorMessages.length > 0" class="p-button-success"
                (click)="openConfirmSaveModal()" label="Save"></button>
              </div>
              <div class="tab-panel-input-wrapper">
                <button pButton type="button" [disabled]="errorMessages.length > 0" class="update-button"
                (click)="openUpdateModal()" label="Update Campaigns"></button>
              </div>
            </div>
            @if (warningMessages.length > 0) {
              <div>
                @for (requiredFields of warningMessages; track requiredFields) {
                  <div>
                    <small class="p-d-block p-message-warn block warning-message">
                      {{requiredFields}}
                    </small>
                  </div>
                }
              </div>
            }
            @if (errorMessages.length > 0) {
              <div>
                @for (requiredFields of errorMessages; track requiredFields) {
                  <div>
                    <small class="p-d-block p-error block">
                      {{requiredFields}}
                    </small>
                  </div>
                }
              </div>
            }
            <p-dialog header="Update Campaigns"
              [(visible)]="displayUpdateModal" [draggable]="false"
              [dismissableMask]="true"
              modal="true"
              position="top"
              [resizable]="false" (onHide)="closeUpdateModal()">
              <p-multiSelect
                [options]="updateCampaignOptions"
                placeholder="Select Campaigns to Update"
                [group]="true"
                appendTo="body"
                [(ngModel)]="selectedCampaignsToUpdate"
                [style]="{'width':'33rem', 'padding':'0.5rem'}">
                <ng-template let-group pTemplate="group">
                  <div class="p-d-flex p-ai-center">
                    <span>{{ group.label }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
              <ng-template pTemplate="footer">
                <div class="update-campaign-button">
                  <button pButton type="button" [disabled]="selectedCampaignsToUpdate.length === 0"
                    (click)="updateCampaigns()" class="p-button-success" label="Update">
                  </button>
                  <button pButton type="button" label="Cancel" (click)="closeUpdateModal()" class="p-button-secondary"></button>
                </div>
              </ng-template>
              @if (selectedCampaignsToUpdate.length !== 0) {
                <div>
                  <p>Selected Campaigns to Update:</p>
                  <ul>
                    @for (campaign of selectedCampaignsToUpdate; track campaign) {
                      <li>
                        <b>{{campaign.get('campaign').value}}</b>
                      </li>
                    }
                  </ul>
                </div>
              }
            </p-dialog>
            <div class="modal-button-wrapper">
              <p-confirmDialog header="Save Campaigns" icon="ui-icon-blank" acceptLabel="Confirm" rejectLabel="Cancel"
                key="saveCampaignsModal"
                acceptButtonStyleClass="p-button-success"
              rejectButtonStyleClass="reject-button"></p-confirmDialog>
            </div>
          </p-panel>
        }
